import React from 'react';
import { Grid } from 'semantic-ui-react';

import { formatDate } from '_utils';
import { licensePoolPropType } from '_utils/licensePools';

import LineItem from '_views/lineItem';

const LicensePoolInfo = ({ licensePool }) => {
  return (
    <Grid>
      <Grid.Row columns={ 2 } >
        <Grid.Column width={ 8 } >
          <LineItem label="Created By" text={ licensePool.created_by.displayname } />
        </Grid.Column>
        <Grid.Column width={ 8 } >
          <LineItem label="Deactivated On" text={ formatDate(licensePool.deactivated_on) } />
          <LineItem label="Deactivated By" text={ licensePool.deactivated_by ? licensePool.deactivated_by.displayname : null } />
        </Grid.Column>
      </Grid.Row>
    </Grid>
  )
};

LicensePoolInfo.propTypes = {
  licensePool: licensePoolPropType.isRequired
};

export default LicensePoolInfo;



// WEBPACK FOOTER //
// ./webAdmin/components/institutions/institution/licensePoolInfo.js